<template>
  <v-container fluid fill-height>
    <v-layout justify-center align-top v-if="init">

      <v-flex text-xs-center v-if="errorMessage === 'unknown'">
        <p style="padding-left: 15px">Произошла неизвестная ошибка, обратитесь к администратору</p>
      </v-flex>

      <v-flex text-xs-center v-if="errorMessage === ''">
        <v-form ref="form" v-model="isValidForm">
          <v-layout row wrap align-center justify-center fill-height>
            <v-flex xs12 text-xs-center>
              <h1>Профиль</h1>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-select
                v-model="selectedCompany"
                :items="availableCompanies"
                @change="changeSetup"
                item-text="name"
                item-value="id"
                label="Компания"
                required
                :rules="emptyFieldRules">
                <template slot='selection' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
                <template slot='item' slot-scope='{ item }'>
                  {{ item.id }} - {{ item.name }}
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7 class="padding5" text-xs-center>
              <v-text-field
                v-model="selectedSetup.smsText"
                label="Текст СМС"
                :hint="'Пример текста сообщения: ' + selectedSetup.smsText + ' evriday.ru/J1RFms'"
                persistent-hint
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-layout row>
                <v-flex xs10 class="padding5">
                  <v-select
                    v-model="selectedSetup.confirmStatus"
                    :items="statusOptions"
                    label="Статус и цвет записи при подтверждении"
                    hint="Статус записи в Yclients, если клиент подтвердит её через приложение"
                  ></v-select>
                </v-flex>

                <v-flex xs2 class="paddingColors">
                  <swatches
                    v-model="selectedSetup.confirmColor"
                    :colors="colors"
                    show-fallback
                    row-length="8"
                    popover-to="left"
                    fallback-ok-text="Ок"
                    fallback-ok-class="colorBtn"
                  ></swatches>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm10 md8 lg7>
              <v-layout row>
                <v-flex xs10 class="padding5">
                  <v-select
                    v-model="selectedSetup.cancelStatus"
                    :items="statusOptions"
                    label="Статус и цвет записи при отмене"
                    hint="Статус записи в Yclients, если клиент отменит её через приложение"
                  ></v-select>
                </v-flex>

                <v-flex xs2 class="paddingColors">
                  <swatches
                    v-model="selectedSetup.cancelColor"
                    :colors="colors"
                    show-fallback
                    row-length="8"
                    popover-to="left"
                  ></swatches>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 text-xs-center>
              <v-btn color="#4169E1" style="color:white" @click="updatePageSetup()">Сохранить</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Swatches from 'vue-swatches'

import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  components: {
    Swatches
  },

  data: () => ({
    colors: ['', '#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#0075B0',
      '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A',
      '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#F55B39', '#FF5722',
      '#795548', '#9E9E9E', '#607D8B'],
    availableSetups: {},
    selectedSetup: {},
    availableCompanies: [],
    selectedCompany: '',
    statusOptions: ['ожидание клиента', 'клиент пришёл', 'клиент не пришёл', 'клиент подтвердил'],
    isValidForm: true,
    emptyFieldRules: [
      v => !!v || 'Необходимо заполнить',
      v => v !== '-1' || 'Необходимо заполнить'
    ],
    errorMessage: '',
    init: false
  }),

  created () {
    this.$store.commit('showNavigation')
    this.getInfo()
  },

  methods: {
    getInfo: function () {
      this.$http.get('/api/setupProfile/getInfo')
        .then(response => {
          if (response.data.error) {
            this.errorMessage = response.data.message
            if (this.errorMessage !== 'unknown') {
              this.$router.push('/assist')
            }
          } else {
            response.data.forEach(item => {
              this.availableCompanies.push({
                id: item.companyId,
                name: item.companyName
              })
              this.availableSetups[item.companyId] = item
              if (item.isDefault === true) {
                this.selectedSetup = item
              }
            })
            if (this.selectedSetup.companyId === undefined) {
              this.selectedSetup = response.data[0]
            }
            this.selectedCompany = this.selectedSetup.companyId
          }
          this.init = true
        })
        .catch(error => {
          this.$store.dispatch('handleError', error.response)
        })
    },
    updatePageSetup: function () {
      if (this.$refs.form.validate()) {
        this.$http.post('/api/setupProfile/update', this.selectedSetup)
          .then(response => {
            this.$store.dispatch('showSnackbar', {
              text: 'Настройки обновлены',
              color: 'success'
            })
          })
          .catch(error => {
            this.$store.dispatch('handleError', error.response)
          })
      }
    },
    changeSetup: function (selectedId) {
      this.selectedSetup = this.availableSetups[selectedId]
    }
  }
}
</script>
